export enum EmailConfirmPath {
  token = "token"
}

export interface PathParams {
  [EmailConfirmPath.token]: string;
}
